export enum AGENT_LIBRARY {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=759113579
     */
    EMPTY_STATE_TITLE = 'AGENT_LIBRARY.EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=759113697
     */
    EMPTY_STATE_DESC = 'AGENT_LIBRARY.EMPTY_STATE_DESC',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=759123619
     */
    START_CHAT = 'AGENT_LIBRARY.START_CHAT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=742414293
     */
    AGENT_LIBRARY = 'AGENT_LIBRARY.AGENT_LIBRARY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=767084800
     */
    AGENT_LIBRARY_PAGE_SUBTITLE = 'AGENT_LIBRARY.AGENT_LIBRARY_PAGE_SUBTITLE',
}
